import React from 'react';
import { connect } from 'react-redux';

import { withRouter, Link } from 'react-router-dom';
import { replace, push } from 'connected-react-router';
import queryString from 'query-string';
import moment from 'moment';

import Typography from '@material-ui/core/Typography';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

import Page from '../../components/Page';
import Avatar from '../../components/Avatar';
import styled from './UsersStyles';
import { actions as userActions } from '../../services/users';

class Users extends React.Component {
  getParams() {
    const defaultParams = {
      status: 'all',
      gender: 'all',
      sort: 'createTime',
      page: 0
    };

    const parsed = queryString.parse(this.props.search);
    const params = Object.assign(defaultParams, parsed);
    params.page = parseInt(params.page);

    return params;
  }

  updateParams(newParams, usePush = false) {
    const params = this.getParams();
    const search = queryString.stringify(Object.assign(params, newParams));
    if (usePush) {
      this.props.actions.push(this.props.pathname + '?' + search);
    }
    else {
      this.props.actions.replace(this.props.pathname + '?' + search);
    }
  }

  componentDidMount() {
    this.props.actions.load(this.getParams());
  }

  setFilter = event => {
    this.updateParams({
      [event.target.name]: event.target.value
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.search !== this.props.search) {
      const { actions } = this.props;
      actions.load(this.getParams());
    }
  }

  nextPage = () => {
    const { page } = this.getParams();
    this.updateParams({ page: page + 1 }, true);
  };

  prevPage = () => {
    const { page } = this.getParams();
    this.updateParams({ page: page - 1 }, true);
  };

  render() {
    console.log('render user page');
    const { classes, loading, users, total, usersPerPage } = this.props;
    const { status, gender, page, sort } = this.getParams();

    let from = usersPerPage * page;
    const to = from + usersPerPage > total ? total : from + usersPerPage;
    from++;

    return (
      <Page title="Users" loading={loading}>
        <Paper className={classes.root}>
          <Toolbar className={classes.toolbar}>
            <Hidden xsDown>
              <Typography>Users - {total}</Typography>
            </Hidden>

            <div className={classes.filters}>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="status">Status</InputLabel>
                <Select
                  value={status}
                  onChange={this.setFilter}
                  inputProps={{
                    name: 'status',
                    id: 'status'
                  }}
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="deleted">Deleted</MenuItem>
                  <MenuItem value="blocked">Blocked</MenuItem>
                </Select>
              </FormControl>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="gender">Gender</InputLabel>
                <Select
                  value={gender}
                  onChange={this.setFilter}
                  inputProps={{
                    name: 'gender',
                    id: 'gender'
                  }}
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="male">Male</MenuItem>
                  <MenuItem value="female">Female</MenuItem>
                </Select>
              </FormControl>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="sort">Sort</InputLabel>
                <Select
                  value={sort}
                  onChange={this.setFilter}
                  inputProps={{
                    name: 'sort',
                    id: 'sort'
                  }}
                >
                  <MenuItem value="createTime">Registered</MenuItem>
                  <MenuItem value="lastActiveTime">Last Active</MenuItem>
                </Select>
              </FormControl>
            </div>
          </Toolbar>
          <div className={classes.tableWrapper}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Avatar</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Age</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Registered</TableCell>
                  <TableCell>Last Active</TableCell>
                  <TableCell>Photos</TableCell>
                  <TableCell>ID</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {users.map(user => (
                  <TableRow key={user._id}>
                    <TableCell>
                      <Avatar user={user} size={100} />
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="text"
                        component={Link}
                        to={`/users/${user._id}`}
                      >
                        {`${user.firstName} ${user.lastName}`}
                      </Button>
                    </TableCell>
                    <TableCell>
                      {moment().diff(new Date(user.dob), 'years')}
                    </TableCell>
                    <TableCell>{user.status}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>
                      {moment(
                        new Date(user.createTime).toUTCString()
                      ).fromNow()}
                    </TableCell>
                    <TableCell>
                      {moment(
                        new Date(user.lastActiveTime).toUTCString()
                      ).fromNow()}
                    </TableCell>
                    <TableCell>{user.photos.length}</TableCell>
                    <TableCell>{user._id}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
          <Toolbar>
            <Typography>Showing {`${from}-${to} of ${total}`}</Typography>
            <div className={classes.pagination}>
              <IconButton disabled={page === 0} onClick={this.prevPage}>
                <KeyboardArrowLeft />
              </IconButton>
              <IconButton disabled={to >= total} onClick={this.nextPage}>
                <KeyboardArrowRight />
              </IconButton>
            </div>
          </Toolbar>
        </Paper>
      </Page>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.users.loading,
    users: state.users.list,
    total: state.users.total,
    usersPerPage: state.users.usersPerPage,
    pathname: state.router.location.pathname,
    search: state.router.location.search
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    load: filters => dispatch(userActions.load(filters)),
    setFilters: payload => dispatch(userActions.setFilters(payload)),
    replace: payload => dispatch(replace(payload)),
    push: payload => dispatch(push(payload))
  }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(styled(Users))
);
